import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';
const utils = require('../components/utils');

const LOADING = 'Loading...';
const baseUrl = `${window.nobid_endpoint}/carbon/pubreports_top_bidders`;


const columnsTopBidders = [
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span>, definition: 'Impressions served.' },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the impression in the currency defined in the Prebid wrapper.' },
  { name: '#Bid Requests', selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'Bid Requests sent out.' },
  { name: '#Bid Responses', selector: 'bid_responses', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_responses) }</span>, definition: 'Bid Responses received.' },
  { name: '%Response Rate', selector: 'response_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.response_rate, '%') }</span>, definition: 'Bid Responses received over Bid Requests sent out.' },
  { name: '$RPM Bid Requests', selector: 'rpm_bid_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_bid_requests) }</span>, definition: 'Bid Responses received over Bid Requests sent out.' },
];
let dataTopBidders = [];
const DashboardTopBiddersComponent = ({params, parentLoading}) => {
  const [loading, setLoading] = useState(true);

  const updateState = (results) => {
    const data = [];
    if (results) results.forEach( r => {
      data.push({bidder_name: r.bidder_name, impressions: r.impressions, revenue: r.revenue
        , bid_requests: r.bid_requests, bid_responses: r.bid_responses, response_rate: r.response_rate
        , rpm_bid_requests: r.rpm_bid_requests});
    });
    dataTopBidders = data;
    setLoading(false);
  }

  const getData = () => {
    setLoading(true);
    const p = params.filter(x => !x.startsWith('_sort=') && !x.startsWith('_end=') && !x.startsWith('_order='));
    p.push('_sort=revenue');
    p.push('_end=30');
    p.push('_order=DESC');
    p.push('show=bidder_name');
    let url = `${baseUrl}?${p.join('&')}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    }).then((results) => {
      updateState(results);
    });
  }

  useEffect(() => { if (parentLoading) getData() }, [parentLoading]);
 
  return (
    <div style={{position: 'relative'}}>
      <DataTable
        title="Top Bidders"
        theme={window.nobid_table_theme()}
        columns={columnsTopBidders}
        data={dataTopBidders}
        progressPending={loading}
        pagination
        fixedHeader
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        dense
        highlightOnHover
      />
    </div>
  )
}

export default DashboardTopBiddersComponent;
